import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled Switch (Group)
 *
 * @param props - children, text
 * @example
 * <SwitchGroup
 * 	id=""
 * 	text="Switch Group"
 * >
 * 	{children}
 * </SwitchGroup>
 * @returns React.ReactElement
 */
var SwitchGroup = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
SwitchGroup.defaultProps = {};
var SampleProps = {};
export default SwitchGroup;
export { SampleProps as SwitchGroupSample, };
